import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Battles",
  "description": "",
  "published": "2007-05-15T00:00:00.000Z",
  "redirect_from": ["/blog/battles/swizec/213"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A fierce battle has been fought yesterday. People suffered and people died but most of all many a bomb went off and mortars spewed out their load by the ton. The countryside is forever changed, those villages will never be the same again. Their men are dead, their women pillaged and their houses raped. The populace suffered greatly as the invading armies ravaged the countryside and the poor crops perished in great numbers.`}</p>
    <p>{`The end result? I passed german.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      